// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3M32b","consentsList":"PatientConsents_consentsList__2TOf1","consentsListEmpty":"PatientConsents_consentsListEmpty__1UTgz"};